module.exports = __webpack_public_path__ + "img/fix_toolbar.62ffe15d.svg";